import React from 'react';
import get from 'lodash/get';
import { BQLink } from '../../atoms/bqlink';
import { getAuthor } from '../../../helpers/utils';
import CardImage from '../../atoms/cardimage';
import './horizontal-bordered-story.module.css';

const HorizontalBorderedStory = props => {
  const story = get(props, ['story', 'story'], {});
  const storyHeadline = get(story, 'headline', null);
  const alternateHeadline = get(story, ['alternative', 'home', 'default', 'headline']);
  const authorObj = getAuthor(story);
  const storyTitle = alternateHeadline || storyHeadline;
  const storyUrl = '/' + get(story, 'slug');

  return (
    <div styleName="wrapper" className="card-image-headline-horizontal">
      <BQLink story={story} href={storyUrl}>
        <CardImage story={story} defaultWidth={36} aspectRatio={[3, 2]} imageType="image3x2" />
      </BQLink>
      <div styleName="content">
        <BQLink story={story} href={storyUrl} styleName="headline">
          {storyTitle}
        </BQLink>
        {authorObj ? (
          <BQLink styleName="by-author" href={authorObj.authorSlug}>
            {authorObj.name}
          </BQLink>
        ) : null}
      </div>
    </div>
  );
};

export default HorizontalBorderedStory;
